import styled from "@emotion/styled";
import { Button } from "@mui/material";
import myThemes from "../../themes/Themes";

export const StyledHeaderButton = styled(Button)(
  ({ label, theme, isFocused }) => ({
    display: "inline",
    verticalAlign: "baseline",
    paddingLeft: "20px",
    paddingRight: "20px",
    paddingTop: "10px",
    paddingBottom: "10px",
    textTransform: "capitalize",
    fontFamily: "Inter",
    color: isFocused
      ? myThemes[theme].palette.primary
      : myThemes[theme].palette.secondary,
    fontSize: "13.5px",
    fontWeight: "500",
    marginLeft: "10px",
    backgroundColor: isFocused ? myThemes[theme].palette.tertiary : "",
    borderRadius: "50px",
    "&:hover": {
      fontWeight: "500",
      filter: isFocused ? "brightness(80%)" : undefined,
      backgroundColor: isFocused ? myThemes[theme].palette.tertiary : "",
      color: isFocused
        ? myThemes[theme].palette.primary
        : myThemes[theme].palette.secondary,
    },
  })
);

export const StyledButton = styled(Button)(({ theme, marginRight, width }) => ({
  textTransform: "capitalize",
  fontFamily: "Inter",
  color: myThemes[theme].palette.senary,
  display: width ? "block" : "inline",
  width: width ? width : "none",
  fontSize: "13px",
  fontWeight: 700,
  height: "36px",
  paddingLeft: "16px",
  paddingRight: "16px",
  backgroundColor: myThemes[theme].palette.tertiary,
  borderRadius: "50px",
  border: `1px solid ${myThemes[theme]}`,
  "&:hover": {
    backgroundColor: myThemes[theme].palette.quarternary,
    color: myThemes[theme].palette.primary,
    border: "none",
  },
  marginRight: marginRight ?? 0,
}));
